import React, { Component } from 'react';
import { DatePicker, Button, Input, Select, message } from 'antd';
import SearchInput from '../../common/SearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';

const { MonthPicker } = DatePicker;
const Option = Select.Option;
const monthFormat = 'YYYY-MM';

class Filter extends Component {
    state = {
        searchParams: {
            startDate: moment().add(1, 'months').format(monthFormat),
            endDate: moment().add(12, 'months').format(monthFormat),
        },
        areaList: [],
        userOptions: [],
        businessList: [],
        hospitalOptions: [],
        departmentOptions: [],
        departmentShow: true,
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    search = () => {
        const { searchParams, params = {} } = this.state;
        this.props.search({
            ...searchParams,
            ...params,
        });
    }

    export = () => {
        this.props.export();
    }

    handleBeignMonth = (date, dateString) => {
        const { searchParams } = this.state;
        const { endDate } = searchParams;
        if (endDate && moment(endDate) < date) {
            message.warning('筛选开始时间不能大于筛选结束时间');
            return;
        }
        searchParams.startDate = dateString;
        this.setState({ searchParams });
    }

    handleEndMonth = (date, dateString) => {
        const { searchParams } = this.state;
        const { startDate } = searchParams;
        if (startDate == '') {
            message.warning('请先选择筛选开始时间');
            searchParams.endDate = '';
        } else if (startDate && dateString && moment(startDate) > date) {
            message.warning('筛选结束时间不能小于筛选开始时间');
            return;
        } else {
            searchParams.endDate = dateString;
        }
        this.setState({ searchParams });
    }

    // 员工
    userSelectChange = value => {
        const { searchParams } = this.state;
        if (value == undefined) {
            searchParams.userId = '';
        } else {
            searchParams.userId = value.key;
        }
        this.setState({ searchParams });
    }

    parseUserData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        if (key == 'departmentId') {
            searchParams[key] = value;
            searchParams.positionIds = '';
            this.setState({
                searchParams,
                showPosition: false,
                positionOptions: [],
            }, () => {
                this.setState({ showPosition: true })
            });
        } else if (key == 'lineOfBusiness') {
            searchParams[key] = value;
            searchParams.secondLineName = undefined;
            this.setState({ searchParams });
        } else {
            searchParams[key] = value;
            this.setState({ searchParams });
        }
    }

    // 医院
    parseHospitalData = (res) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.hospitalName}`,
                value: item.hospitalId,
            }));
            this.setState({ hospitalOptions: data });
        } else {
            this.setState({ hospitalOptions: [] });
        }
    }

    hospitalSelectChange = value => {
        const { searchParams } = this.state;
        if (!value) {
            searchParams.hospitalId = '';
        } else {
            searchParams.hospitalId = value.key;
        }
        searchParams.departmentId = '';
        this.setState({
            searchParams,
            departmentShow: false,
            departmentOptions: [],
        }, () => {
            this.setState({ departmentShow: true });
        });
    }

    // 科室
    parseDepartmentData = (res) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.datas;
            const data = sourceData.map(item => ({
                text: `${item.departmentLocalName}`,
                value: item.hospitalDepartmentId,
            }));
            this.setState({ departmentOptions: data });
        } else {
            this.setState({ departmentOptions: [] });
        }
    }

    departmentSelectChange = value => {
        const { searchParams } = this.state;
        if (!value) {
            searchParams.departmentId = '';
        } else {
            searchParams.departmentId = value.key;
        }
        this.setState({ searchParams });
    }

    departmentFocus = () => {
        const { searchParams: { hospitalId }, hospitalOptions } = this.state;
        const isExist = hospitalOptions.some(item => item.value == hospitalId);
        if (!isExist) {
            message.warning('请先选择医院');
            return;
        }
        return hospitalId;
    }

    addMember = () => {
        this.props.addMember();
    }

    render() {
        const {
            searchParams,
            areaList,
            userOptions,
            businessList,
            hospitalOptions,
            departmentOptions,
            departmentShow
        } = this.state;
        const {
            endDate,
            startDate,
            hospitalId,
            lineOfBusiness,
        } = searchParams;
        const newStartDate = startDate ? moment(startDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaOption = areaList.map(d => <Option key={d.investigationAreaId}>{d.investigationAreaName}</Option>);
        return (
            <div className="filter-bar bar2">
                <div className="form-item" style={{height: 30}}>
                    <label htmlFor="" className="ui-label">SSU人员安排时间</label>
                    <MonthPicker
                        style={{width:90}}
                        format={monthFormat}
                        value={newStartDate}
                        onChange={this.handleBeignMonth}
                        className="w-90-select"
                        placeholder="请选择"
                        allowClear={true}
                    />
                </div>
                <div className="form-item" style={{height: 30}}>
                    <label htmlFor="" className="ui-label">至</label>
                    <MonthPicker
                        style={{width:90}}
                        format={monthFormat}
                        value={newEndDate}
                        onChange={this.handleEndMonth}
                        className="w-90-select"
                        placeholder="请选择"
                        allowClear={true}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">姓名/工号</label>
                    <SearchInput
                        name="user"
                        style={{ width: 162 }}
                        url={API_URL.investigation.queryUserByKey}
                        keyword='keyword'
                        dataSource={userOptions}
                        parseData={this.parseUserData}
                        handleSelect={this.userSelectChange}
                        placeholder='请输入姓名/工号自动检索'
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">工作城市</label>
                    <Input placeholder="请输入" onChange={e => this.handleInputChange(e, 'workCity')} />
                </div>
                <div className="form-item">
                    <label className="ui-label">项目领域</label>
                    <Select
                        allowClear={true}
                        style={{ width: 120 }}
                        onChange={value => this.handleSelectChange(value, 'investigationAreaId')}
                        placeholder="请选择"
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label className="ui-label">项目编号</label>
                    <Input placeholder="请输入" onChange={e => this.handleInputChange(e, 'investigationCode')} />
                </div>
                <div className="form-item">
                    <label className="ui-label">项目简称</label>
                    <Input placeholder="请输入" onChange={e => this.handleInputChange(e, 'investigationName')} />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">医院</label>
                    <SearchInput 
                        style={{width:162}}
                        params={{ limit: 20 }}
                        url={API_URL.hospital.hospitalList}
                        keyword='hospitalName'
                        dataSource={hospitalOptions}
                        parseData={this.parseHospitalData}
                        handleSelect={this.hospitalSelectChange}
                        placeholder='请输入医院名称自动检索'
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">科室</label>
                    {
                        departmentShow &&
                        <SearchInput 
                            style={{width:162}}
                            url={API_URL.hospital.queryDepWhenAddDoctor}
                            keyword='hospitalDepName'
                            params={{ hospitalId }}
                            dataSource={departmentOptions}
                            parseData={this.parseDepartmentData}
                            handleSelect={this.departmentSelectChange}
                            placeholder='请输入科室名称自动检索'
                            handleFocus={this.departmentFocus}
                        />
                    }
                </div>
                <div className="form-item">
                    <label className="ui-label">中心是否启动</label>
                    <Select
                        allowClear={true}
                        style={{ width: 80 }}
                        onChange={value => this.handleSelectChange(value, 'siteIsStart')}
                        placeholder="请选择"
                    >
                        <Option value="1">是</Option>
                        <Option value="0">否</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleSelectChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        disabled={!lineOfBusiness}
                        value={searchParams.secondLineName}
                        onChange={value => this.handleSelectChange(value, 'secondLineName')}
                    >
                        {secondLineOption}
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/hospital/Staffing/Filter.js